import { render, staticRenderFns } from "./SelectedClientCard.vue?vue&type=template&id=3777aec7&"
import script from "./SelectedClientCard.vue?vue&type=script&lang=js&"
export * from "./SelectedClientCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports